import { trackAnalyticsEvent } from '@/app/lib/analytics';
import { ANALYTICS_EVENTS, COMPARE_PLANS_URL } from '@/constants';

import type { LinkProps } from 'next/link';

export const handleButtonClickAnalytics = (
  href: LinkProps['href'],
  pathname: string
) => {
  if (href === COMPARE_PLANS_URL) {
    trackAnalyticsEvent(ANALYTICS_EVENTS.compareEnergyPlans.pageLanded, { location: pathname });
  }
};
